import React from "react";
import "./index.scss";
import CountUp from "react-countup";
import { useHistory } from "react-router-dom";
import { Card, Typography } from "antd";
const { Title } = Typography;
const DeliveryBox = (boxData) => {
  const history = useHistory();
  const { hover } = boxData.data;
  const cardStyle = {
    backgroundColor: boxData.data.color,
  };

  if (hover) {
    cardStyle["--hover-bg"] = hover.backgroundColor;
    cardStyle["--hover-border"] = hover.borderColor;
  }

  return (
    <Card
      style={cardStyle}
      className={`delivery-result-card${
        hover ? " delivery-result-card--hoverable" : ""
      }`}
      onClick={() => {
        let url = `/deliveries/operation?status=${boxData.data.status}`;
        if (boxData?.selectedMerchant) {
          url += `&merchantId=${boxData.selectedMerchant}`;
        }
        history.push(url);
      }}
    >
      <div className="delivery-result-box">
        {boxData.data.icon}
        <Title
          level={4}
          style={{
            marginBottom: 16,
            textAlign: "center",
            color: boxData.data.textColor,
          }}
        >
          {boxData.data.text}
        </Title>
        <h2
          style={{
            color: boxData.data.textColor,
            fontSize: 32,
            fontWeight: 700,
            lineHeight: "44px",
          }}
        >
          <CountUp end={boxData.data.value} duration={0.75} />
        </h2>
      </div>
    </Card>
  );
};

export default DeliveryBox;
